/* eslint-disable */
export const env = Object.freeze({
  // window.location.hostname
  PRD: 'atendimento.dasa.com.br',
  MAX_INSTALLMENTS_LENGTH: 10,
  PAYMENT_PROVIDER: 'braspag'
});
/* eslint-enable */
